import { MAILTO } from "./Nav";
import SocialIcons from "./SocialIcons";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-[#050505] border-t border-[#26262a]"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 pb-10">
                <div className="grid md:grid-cols-12 gap-10 mb-16">
                    <div className="md:col-span-5">
                        <img
                            src="/pixelgrok-logo.png"
                            alt="Pixelgrok Media"
                            className="h-20 md:h-28 w-auto mb-8 select-none"
                            draggable="false"
                        />
                        <p className="font-serif-display italic text-2xl md:text-3xl leading-snug max-w-lg">
                            From the pixel to the podium —{" "}
                            <span className="text-[#e6192b]">
                                media that delivers.
                            </span>
                        </p>
                        <div className="mt-8">
                            <div className="text-[11px] uppercase tracking-[0.22em] text-[#e6192b] mb-3">
                                Follow
                            </div>
                            <SocialIcons size="md" variant="ghost" />
                        </div>
                    </div>

                    <div className="md:col-span-2">
                        <div className="text-[11px] uppercase tracking-[0.22em] text-[#e6192b] mb-4">
                            Studio
                        </div>
                        <ul className="space-y-2 text-[#a0a0ab] text-[14px]">
                            <li>
                                <a href="#services" className="red-link hover:text-white">
                                    Services
                                </a>
                            </li>
                            <li>
                                <a href="#geo" className="red-link hover:text-white">
                                    GEO
                                </a>
                            </li>
                            <li>
                                <a href="#process" className="red-link hover:text-white">
                                    Process
                                </a>
                            </li>
                            <li>
                                <a href="#why" className="red-link hover:text-white">
                                    Why us
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-5">
                        <div className="text-[11px] uppercase tracking-[0.22em] text-[#e6192b] mb-4">
                            Reach
                        </div>
                        <a
                            href={MAILTO}
                            data-testid="footer-email"
                            className="block font-serif-display text-2xl md:text-3xl mb-3 hover:text-[#e6192b] transition-colors"
                        >
                            contact@pixelgrok.com
                        </a>
                        <a
                            href="https://www.pixelgrok.com"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-website"
                            className="text-[#a0a0ab] hover:text-white red-link"
                        >
                            www.pixelgrok.com ↗
                        </a>
                    </div>
                </div>

                <div className="hairline mb-6" />
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.22em] text-[#5a5a63]">
                    <span>
                        © {new Date().getFullYear()} Pixelgrok Media · Estd. 2021
                    </span>
                    <span className="flex items-center gap-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-[#e6192b] blink" />
                        Engineered for the AI-First Era
                    </span>
                </div>
            </div>
        </footer>
    );
}
